// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
  },
  subMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 700,
    [theme.breakpoints.down(1050)]: {
      width: '60%',
    },
    [theme.breakpoints.down(800)]: {
      width: '90%',
    },
  },
  title: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    width: 'fit-content',
    marginBottom: 20,
  },
  faqsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    zIndex: 10,
  },
});

export default styles;
